interface ProcessFilterParams {
  filters: Record<string, any>;
}
export function processFilterParams({
  filters = {},
}: ProcessFilterParams): URLSearchParams {
  const params = new URLSearchParams();

  Object.keys(filters).forEach((key) => {
    const value = filters[key];

    if (value) {
      params.append(toSnake(key), value);
    }
  });

  return params;
}

function toSnake(s: string): string {
  return s.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
}
